/*
import {
  _hm,
  _hmDTM,
  _ht,
  useGblz,
  f,
  gs,
  _cv_61___Mz,
} from 'lib';
*/

import * as _hm from "./_hf";
import * as _hmDTM from "./_hfDTM";
import * as _ht from './_ht';
import * as _cm from "./_cm";
import * as _cmFTH from "./_cmFTH"; // 廃止予定
import * as gs from "./_csGbl";
import * as _cv_61___Mz from "./_cv_61___Mz"; // 休日

import * as ihd from './ihd';
import * as ihdI1z from './ihdI1z';
import * as ihm from './ihm';
import * as icm from './icm';
import * as icv from './icv';

import * as icvI10___Mz from './icvI10___Mz';
import * as icvI17___Mz from './icvI17___Mz';

export const ilzI1zz = () => ({ 
  i1zrz: {},
  i1z1s: [],
  i1z2s: [],
  i1z3z: {},
  i1z4z: {},
  i18rz: {},
}) as _ht.dz;

export const crtI1zz = (pz?: {
  i1zrz?: _ht.dz,
  i1z3z?: _ht.dz,
}) => {
  const _gUserz = gs.useGblz('user');
  const _i1zz = ilzI1zz();
  _hm.udtDz(_i1zz.i1zrz, {
    ... ihd.i('i1zr'),
    i1zr_31r1f: _gUserz.crt._31rz?._fst,
    i1zrd1100s: _hmDTM.getTdy(),
    i1zrd2100s: _hmDTM.getTdy(),
    ... pz?.i1zrz,
//    i1zrd3100s: _hmDTM.getTdy(),
  });
  _i1zz.i1z1s = [];
  _i1zz.i1z2s = [];
  _hm.udtDz(_i1zz.i1z3z, ihd.i('i1z3'));
  if (pz?.i1z3z) _hm.udtDz(_i1zz.i1z3z, pz.i1z3z);
  _hm.udtDz(_i1zz.i1z4z, ihd.i('i1z4'));
  return _i1zz;
};

export const load_31rLsAsync = async ( pz: {
  i18r_fst: _ht.n,
  sttDtm?: _ht.s,
  endDtm?: _ht.s,
  i1zrs1100iMnm?: _ht.n, // minimum i1zrs1100i
  i1zrs1200iMnm?: _ht.n, // minimum i1zrs1100i
  lwrz?: _ht.dz,
} ) => {

  let _cdn = _cmFTH.vdd() + ' AND i1zr_31r1f = {_31r_fst}';
  if ( pz.i18r_fst ) _cdn += ` AND i1zri18r1f = '${pz.i18r_fst}'`;
  if ( pz.sttDtm ) _cdn += ` AND i1zrd3100s >= '${pz.sttDtm}'`;
  if ( pz.endDtm ) _cdn += ` AND i1zrd3100s <= '${pz.endDtm}'`;
  if ( pz.i1zrs1100iMnm ) _cdn += ` AND i1zrs1100i >= ${pz.i1zrs1100iMnm}`;
  if ( pz.i1zrs1200iMnm ) _cdn += ` AND i1zrs1200i >= ${pz.i1zrs1200iMnm}`;

//  _hm.l(`Iccv13b1a 45: ${_hm.s(_cdn)}`);

  const _ls = await _cmFTH.loadLsAsync({
    tgt: '_31rs',
    cdn: _cmFTH.vdd(),
    lwrz: {
      i1zrs: {
        tgt: 'i1zrs',
        cdn: _cdn,
        rlcz: {
          _31r_fst: '_31rs._fst',
        },
        tailz: {
          odr: 'i1zrd3100s desc, i1zra1200s, i1zra1100s, _icn'
        },
        lwrz: {
          i1z3s: {
            tgt: 'i1z3s',
            cdn: _cmFTH.vdd() + ` AND i1z3i1zr1k={i1zr_key}`,
            rlcz: {
              i1zr_key: 'i1zrs._key',
            },
          }
        }
      },
      ... pz.lwrz,
    }
  })
  return _ls;
};


export const loadI1zrLsAsync = async ( pz: {
  _31r_fst?: _ht.n, // 他の施設を参照する可能性があるため施設を指定可能とする
  i18r_fst?: _ht.n,
  i1zrd3100s?: _ht.s,
  i1zrd3100sStt?: _ht.s,
  i1zrd3100sEnd?: _ht.s,
  yearMth?: _ht.s,
  i1zrs1100i?: _ht.n, // i1zrs1100i
  i1zrs1100iMnm?: _ht.n, // minimum i1zrs1100i
  i1zrs1100is?: _ht.ls, // i1zrs1100i list
  i1zrs1200i?: _ht.n, // i1zrs1200i
  i1zrs1200iMnm?: _ht.n, // minimum i1zrs1200i
  i1zrs1200is?: _ht.ls, // i1zrs1200i list
  i1zr_fst?: _ht.n,
  fld?: _ht.s,
  tailz?: _ht.dz,
  lwrType?: 1,
  _dlt?: _ht.n,
} ) => {

  let _cdn = _cmFTH.vdd(undefined, undefined, pz._dlt ? false : true);
  if ( pz._31r_fst && pz._31r_fst > 0 ) _cdn += ` AND i1zr_31r1f = ${pz._31r_fst}`;
  if ( pz.i18r_fst && pz.i18r_fst > 0) _cdn += ` AND i1zri18r1f = ${pz.i18r_fst}`;
  if ( pz.i1zrd3100s ) _cdn += ` AND i1zrd3100s = '${pz.i1zrd3100s}'`;
  if ( pz.i1zrd3100sStt ) _cdn += ` AND i1zrd3100s >= '${pz.i1zrd3100sStt}'`;
  if ( pz.i1zrd3100sEnd ) _cdn += ` AND i1zrd3100s <= '${pz.i1zrd3100sEnd}'`;
  if ( pz.yearMth ) _cdn += ` AND i1zrd3100s LIKE '${pz.yearMth}%'`;
  if ( pz.i1zrs1100i && pz.i1zrs1100i < 900 && pz.i1zrs1100i > 0) _cdn += ` AND i1zrs1100i = ${pz.i1zrs1100i}`;
  if ( pz.i1zrs1100i && pz.i1zrs1100i == 990) _cdn += ` AND i1zrs1100i IN (80, 90)`;
//  if ( pz.i1zrs1100i && pz.i1zrs1100i == 999) _cdn += ` AND i1zrs1100i IN (20, 70, 80, 90)`;
  if ( pz.i1zrs1100i && pz.i1zrs1100i == 999) _cdn += ` AND i1zrs1100i IN (22, 24, 26, 70, 80, 90)`;
  if ( pz.i1zrs1100is && _hm.f(pz.i1zrs1100is) ) _cdn += ` AND i1zrs1100i IN (${pz.i1zrs1100is.join(',')})`;
  if ( pz.i1zrs1100iMnm ) _cdn += ` AND i1zrs1100i >= ${pz.i1zrs1100iMnm}`;
  if ( pz.i1zrs1200i && pz.i1zrs1200i < 900 && pz.i1zrs1200i > 0) _cdn += ` AND i1zrs1200i = ${pz.i1zrs1200i}`;
  if ( pz.i1zrs1200i && pz.i1zrs1200i == 999) _cdn += ` AND i1zrs1200i IN (20, 60, 70, 80, 90)`;
  if ( pz.i1zrs1200iMnm ) _cdn += ` AND i1zrs1200i >= ${pz.i1zrs1200iMnm}`;
  if ( pz.i1zrs1200is && _hm.f(pz.i1zrs1200is) ) _cdn += ` AND i1zrs1200i IN (${pz.i1zrs1200is.join(',')})`;
  if ( pz.i1zr_fst ) _cdn += ` AND _fst <> ${pz.i1zr_fst}`;
  if ( pz._dlt ) _cdn += ` AND _dlt = ${pz._dlt}`;

  //hf.l(`icvI1z___Mz 125: ${_cdn}`);
  const _ls = await _cmFTH.loadLsAsync({
    tgt: 'i1zrs',
    cdn: _cdn,
    fld: pz.fld ?? '*',
    tailz: pz.tailz ?? {
//      odr: 'i1zrd3100s desc, i1zra1100s, i1zra1200s, i1zri18r1f'
      odr: 'i1zrd3100s desc, i1zra1110s, i1zra1210s, i1zri18r1f'
    },
    lwrz: 
      pz.lwrType == 1 ?
      {
        _31rs: {
          tgt: '_31rs',
          cdn: _cmFTH.vdd() + ` AND _fst = {i1zr_31r1f}`,
          rlcz: {
            i1zr_31r1f: 'i1zrs.i1zr_31r1f',
          }
        },
        i18rs: {
          tgt: 'i18rs',
          cdn: _cmFTH.vdd() + ` AND _fst = {i1zri18r1f}`,
          rlcz: {
            i1zri18r1f: 'i1zrs.i1zri18r1f',
          },
          lwrz: {
            i15rs: {
              tgt: 'i15rs',
              cdn: _cmFTH.vdd() + ` AND _fst = {i18ri15r1f}`,
              rlcz: {
                i18ri15r1f: 'i18rs.i18ri15r1f',
              }
            },
          }
        },
        i1z1s: {
          tgt: 'i1z1s',
          cdn: _cmFTH.vdd() + ` AND i1z1i1zr1k = {i1zr_key}`,
          rlcz: {
            i1zr_key: 'i1zrs._key',
          }
        },
        i1z3s: {
          tgt: 'i1z3s',
          cdn: _cmFTH.vdd() + ` AND i1z3i1zr1k = {i1zr_key}`,
          rlcz: {
            i1zr_key: 'i1zrs._key',
          }
        },
        i1z4s: {
          tgt: 'i1z4s',
          cdn: _cmFTH.vdd() + ` AND i1z4i1zr1k = {i1zr_key}`,
          rlcz: {
            i1zr_key: 'i1zrs._key',
          }
        },
      }
      : undefined,
  })
  return _ls;
};

export const loadI1zrDzAsync = async ( pz: { // 他の施設を参照する場合があるため _31r_fst を固定しない
//  _31r_fst?: _ht.n, 
  i1zr_fst: _ht.n,
  vsn?: _ht.n,
  lwrz?: {
    i111z?: _ht.b,
  }
} ) => {
  //let _cdn = _cmFTH.vdd() + ` AND _fst=${pz.i1zr_fst}`;
  let _cdn = (pz?.vsn && pz?.vsn > 0) ? (_cmFTH.vdd(false) + ` AND _vsn = ${pz?.vsn}`) : _cmFTH.vdd();
  _cdn += ` AND _fst = ${pz.i1zr_fst}`;
  //hf.l(`IcvI1z 148: ${_cdn}`);
  const _dz = await _cmFTH.loadDzAsync({
    tgt: 'i1zrs',
    cdn: _cdn,
    lwrz: {
      i1z1s: {
        tgt: 'i1z1s',
        cdn: _cmFTH.vdd() + ` AND i1z1i1zr1k = {i1zr_key}`,
        rlcz: {
          i1zr_key: 'i1zrs._key',
        },
        lwrz: {
          i10rs: {
            tgt: 'i10rs',
            cdn: _cmFTH.vdd() + ` AND _fst = {i1z1i10r1f}`,
            rlcz: {
              i1z1i10r1f: 'i1z1s.i1z1i10r1f'
            }
          },
          i11rz: {
            tgt: 'i10rs',
            cdn: _cmFTH.vdd() + ` AND _fst = {i1z1i10r1f}`,
            rlcz: {
              i1z1i10r1f: 'i1z1s.i1z1i10r1f'
            }
          }
        }
      },
      i1z2s: {
        tgt: 'i1z2s',
        cdn: _cmFTH.vdd() + ` AND i1z2i1zr1k = {i1zr_key}`,
        rlcz: {
          i1zr_key: 'i1zrs._key',
        },
        lwrz: {
          i17rs: {
            tgt: 'i17rs',
            cdn: _cmFTH.vdd() + ` AND _fst = {i1z2i17r1f}`,
            rlcz: {
              i1z2i17r1f: 'i1z2s.i1z2i17r1f'
            }
          }
        }
      },
      i1z3s: {
        tgt: 'i1z3s',
        cdn: _cmFTH.vdd() + ` AND i1z3i1zr1k = {i1zr_key}`,
        rlcz: {
          i1zr_key: 'i1zrs._key',
        },
      },
      i1z4s: {
        tgt: 'i1z4s',
        cdn: _cmFTH.vdd() + ` AND i1z4i1zr1k = {i1zr_key}`,
        rlcz: {
          i1zr_key: 'i1zrs._key',
        },
      },
      i18rs: {
        tgt: 'i18rs',
        cdn: _cmFTH.vdd() + ` AND _fst = {i1zri18r1f}`,
        rlcz: {
          i1zri18r1f: 'i1zrs.i1zri18r1f',
        },
        lwrz: {
          i15rs: {
            tgt: 'i15rs',
            cdn: _cmFTH.vdd() + ` AND _fst = {i18ri15r1f}`,
            rlcz: {
              i18ri15r1f: 'i18rs.i18ri15r1f',
            },
          },
        }
      },
      _31rs: {
        tgt: '_31rs',
        cdn: _cmFTH.vdd() + ` AND _fst = {i1zr_31r1f}`,
        rlcz: {
          i1zr_31r1f: 'i1zrs.i1zr_31r1f',
        },
      }
    }
  });
  //hf.l(`icvi1z___Mz 292: ${_hm.s(_dz.cldz?.i18rs)}`)
  const _i18rz = _hm.get1(_dz.cldz?.i18rs, {});
  const _i15rz = _hm.get1(_i18rz.cldz?.i15rs, {});
  return {
    i1zrz: { ... _dz, cldz: undefined },
    i1z1s: _dz.cldz?.i1z1s ?? [],
    i1z2s: _dz.cldz?.i1z2s ?? [],
    i1z3z: _hm.get1(_dz.cldz?.i1z3s, {}),
    i1z4z: _hm.get1(_dz.cldz?.i1z4s, {}),
    i18rz: { ... _i18rz, cldz: undefined },
    i15rz: _i15rz,
    _31rz: _hm.get1(_dz.cldz?._31rs, {}),
  }

};

export const loadI1z1LsAsync = async ( pz: {
  _31r_fst: _ht.n,
  i1zrd3100s?: _ht.s,
  i1zrd3100sStt?: _ht.s,
  i1zrd3100sEnd?: _ht.s,
  i10r_fst?: _ht.n, //複合部屋を含む
  i10r_fsts?: _ht.ls,
  i1zr_fst?: _ht.n,
  i1zrs1100iMnm?: _ht.n, // minimum i1zrs1100i
  i1z1a1100i?: _ht.n, // stt time
  i1z1a1200i?: _ht.n, // end time
  fld?: _ht.s,
  tailz?: _ht.dz,
  lwrType?: _ht.n,
} ) => {

  const _gUserz = gs.useGblz('user');

//  let _cdn = _cmFTH.vdd() + ` AND i1z1_31r1f=${_gUserz.crt._31rz._fst}`;
  let _cdn = _cmFTH.vdd() + ` AND i1z1_31r1f=${pz._31r_fst}`;

  if ( pz.i1zrd3100s ) _cdn += ` 
    AND i1z1i1zr1k IN (
      SELECT 
        _key 
      FROM 
        i1zrs 
      WHERE 
        ${_cmFTH.vdd()} 
        AND i1zr_31r1f = ${pz._31r_fst} 
        AND i1zrd3100s = '${pz.i1zrd3100s}' 
        AND i1zrs1100i >= ${pz.i1zrs1100iMnm ?? -1}
    )`;
  if ( pz.i1zrd3100sStt && pz.i1zrd3100sEnd ) _cdn += ` 
    AND i1z1i1zr1k IN (
      SELECT 
        _key 
      FROM 
        i1zrs 
      WHERE 
        ${_cmFTH.vdd()} 
        AND i1zr_31r1f = ${pz._31r_fst} 
        AND i1zrd3100s >= '${pz?.i1zrd3100sStt}' 
        AND i1zrd3100s <= '${pz?.i1zrd3100sEnd}' 
        AND i1zrs1100i >= ${pz.i1zrs1100iMnm ?? -1}
      )`;
  if ( pz.i1zr_fst ) _cdn += ` 
    AND i1z1i1zr1k NOT IN (
      SELECT 
        _key 
      FROM 
        i1zrs 
      WHERE 
        ${_cmFTH.vdd()} 
        AND _fst = ${pz.i1zr_fst}
    )`; // Not であることに注意
  if ( pz.i10r_fst ) _cdn += ` 
    AND (
      i1z1i10r1f = ${pz.i10r_fst} 
      OR i1z1i10r1f IN (
        SELECT
          _fst
        FROM
          i10rs
        WHERE
          ${_cmFTH.vdd(false)}
          AND _key IN (
            SELECT 
              i102i10r1k
            FROM 
              i102s 
            WHERE 
              ${_cmFTH.vdd()} 
              AND i102i10r1f = ${pz.i10r_fst}
          )
      )
      OR i1z1i10r1f IN (
        SELECT 
          i102i10r1f
        FROM 
          i102s 
        WHERE 
          ${_cmFTH.vdd()} 
          AND i102i10r1k = (
            SELECT
              _key
            FROM
              i10rs
            WHERE
              ${_cmFTH.vdd()}
              AND _fst = ${pz.i10r_fst}
          )
      )
      OR i1z1i10r1f IN (
        SELECT
          _fst
        FROM
          i10rs
        WHERE
          ${_cmFTH.vdd()}
          AND _key IN (
            SELECT
              i102i10r1k
            FROM
              i102s
            WHERE
              ${_cmFTH.vdd()}
              AND i102i10r1f IN (
                SELECT 
                  i102i10r1f
                FROM 
                  i102s 
                WHERE 
                  ${_cmFTH.vdd()} 
                  AND i102i10r1k = (
                    SELECT
                      _key
                    FROM
                      i10rs
                    WHERE
                      ${_cmFTH.vdd()}
                      AND _fst = ${pz.i10r_fst}
                  )
              )
          )
      )
    )`; // 複合部屋を考慮
  if ( pz.i1z1a1100i ) _cdn += ` AND i1z1a1200i > ${pz.i1z1a1100i}`;
  if ( pz.i1z1a1200i ) _cdn += ` AND i1z1a1100i < ${pz.i1z1a1200i}`;

//  if ( _hm.f(pz.i10r_fsts) ) _cdn += ` AND i1z1i10r1f IN (${pz.i10r_fsts?.join(`,`)})`;
  if ( _hm.f(pz.i10r_fsts) ) _cdn += ` AND i1z1i10r1f IN (${_hm.join(pz.i10r_fsts)})`;

  //hf.l(`IcvI1z 367: ${_cdn}`)
  return await _cmFTH.loadLsAsync({
    tgt: 'i1z1s',
    cdn: _cdn,
    fld: pz.fld ?? '*',
    tailz: pz.tailz,
    lwrz: 
      pz.lwrType == 1 ?
      {
        i1zrs: {
          tgt: 'i1zrs',
          cdn: _cmFTH.vdd() + ` AND _key={i1z1i1zr1k}`,
          rlcz: {
            i1z1i1zr1k: 'i1z1s.i1z1i1zr1k',
          },
        },
      }
      : undefined,
  })
};

export const loadI1z2LsAsync = async ( pz: {
  _31r_fst: _ht.n,
  i17r_fst: _ht.n,
  i1zr_fst?: _ht.n,
  i1zrd3100s?: _ht.s, // date
  i1zrs1100iMnm?: _ht.n, // minimum i1zrs1100i
  i1z2a1100i?: _ht.n, // sttTime
  i1z2a1200i?: _ht.n, // endTime
  fld?: _ht.s,
  tailz?: _ht.dz,
} ) => {

//  const _gUserz = useGblz('user');

//  let _cdn = _cmFTH.vdd() + ` AND i1z2_31r1f=${_gUserz.crt._31rz._fst}`;
  let _cdn = _cmFTH.vdd();
  if ( pz._31r_fst ) _cdn += ` AND i1z2_31r1f=${pz._31r_fst}`;
  if ( pz.i17r_fst ) _cdn += ` AND i1z2i17r1f=${pz.i17r_fst}`;

  if ( pz.i1zrd3100s ) _cdn += ` AND i1z2i1zr1k IN (SELECT _key FROM i1zrs WHERE ${_cmFTH.vdd()} AND i1zr_31r1f=${pz._31r_fst} AND i1zrd3100s='${pz.i1zrd3100s}' AND i1zrs1100i>${pz.i1zrs1100iMnm ?? -1})`;
  if ( pz.i1zr_fst ) _cdn += ` AND i1z2i1zr1k NOT IN (SELECT _key FROM i1zrs WHERE ${_cmFTH.vdd()} AND i1zr_31r1f=${pz._31r_fst} AND _fst=${pz.i1zr_fst})`;
  //if ( pz.i1z2a1100i ) _cdn += ` AND i1z2a1200i>=${pz.i1z2a1100i}`;
  if ( pz.i1z2a1100i ) _cdn += ` AND i1z2a1200i>${pz.i1z2a1100i}`;
  if ( pz.i1z2a1200i ) _cdn += ` AND i1z2a1100i<${pz.i1z2a1200i}`; 
  //hf.l(`icvI1z___Mz 500a: ${_cdn}`);
  const _ls = await _cmFTH.loadLsAsync({
    tgt: 'i1z2s',
    cdn: _cdn,
    tailz: pz.tailz,
  });
  //hf.l(`icvI1z___Mz 500b: ${_hm.s(_ls)}`);
  return _ls;
};

/*
export const loadI1z5RzAsync = async ( pz: {
  _31r_fst: _ht.n,
  i10r_fsts?: _ht.ls,
  dates?: _ht.ls,
  i1zrd3100sStt?: _ht.s,
  i1zrd3100sEnd?: _ht.s,
}) => {
  const _gUserz = gs.useUserz();
  let _cdn = _cmFTH.vdd(false) + ` AND i1z5_31r1f=${pz._31r_fst}`;
  if (_hm.f(pz.i10r_fsts)) _cdn += ` AND i1z5i10r1f IN (${_hm.join(pz.i10r_fsts)})`;
  if (pz.dates) _cdn += ` AND i1z5d1100s IN (${_hm.join(pz.dates, ',', `'`)})`;
  if (_hm.f(pz.i1zrd3100sStt)) _cdn += ` AND i1z5d1100s >= '${pz.i1zrd3100sStt}'`;
  if (_hm.f(pz.i1zrd3100sEnd)) _cdn += ` AND i1z5d1100s <= '${pz.i1zrd3100sEnd}'`;
  const _ls = await _cmFTH.loadLsAsync({
    tgt: 'i1z5s',
    cdn: _cdn,
  });
  const _dz = {} as _ht.dz;
  _ls.map((_i1z5z: _ht.dz) => {
    if (!_dz[_i1z5z.i1z5i10r1f]) _dz[_i1z5z.i1z5i10r1f] = {};
    if (!_dz[_i1z5z.i1z5i10r1f][_i1z5z.i1z5i1111f]) _dz[_i1z5z.i1z5i10r1f][_i1z5z.i1z5i1111f] = {};
    _dz[_i1z5z.i1z5i10r1f][_i1z5z.i1z5i1111f][_i1z5z.i1z5d1100s] = {
      i1z5a1100i: _i1z5z.i1z5a1100i,
      i1z5a2100i: _i1z5z.i1z5a2100i,
    };
  });
  return _dz;
};
*/

/*
export const loadI1z5RzAsync = async ( pz: {
  _31r_fst: _ht.n,
  i10r_fsts?: _ht.ls,
  dates?: _ht.ls,
  i1zrd3100sStt?: _ht.s,
  i1zrd3100sEnd?: _ht.s,
}) => {
  const _gUserz = gs.useUserz();
  let _cdn = _cmFTH.vdd(false) + ` AND i1z5_31r1f=${pz._31r_fst}`;
  if (_hm.f(pz.i10r_fsts)) _cdn += ` AND i1z5i10r1f IN (${_hm.join(pz.i10r_fsts)})`;
  if (pz.dates) _cdn += ` AND i1z5d1100s IN (${_hm.join(pz.dates, ',', `'`)})`;
  if (_hm.f(pz.i1zrd3100sStt)) _cdn += ` AND i1z5d1100s >= '${pz.i1zrd3100sStt}'`;
  if (_hm.f(pz.i1zrd3100sEnd)) _cdn += ` AND i1z5d1100s <= '${pz.i1zrd3100sEnd}'`;
  const _ls = await _cmFTH.loadLsAsync({
    tgt: 'i1z5s',
    cdn: _cdn,
    lwrz: {
      i10rs: { // 親部屋, i10rs を _key で引き当てており、最新情報でない場合があることに留意
        tgt: 'i10rs',
        cdn: _cmFTH.vdd(false) + ` AND _key IN (
          SELECT
            i102i10r1k
          FROM
            i102s
          WHERE
            ${_cmFTH.vdd()}
            AND i102i10r1f = {i102i10r1f}
        )`,
        rlcz: {
          i102i10r1f: 'i1z5s.i1z5i10r1f',
        }
      }
    }
  });
  //hf.l(`icvI1z___Mz 579: ${_hm.s(_ls)}`);
  const _dz = {} as _ht.dz;
  _ls.map((_i1z5z: _ht.dz) => {
    if (!_dz[_i1z5z.i1z5i10r1f]) {
      _dz[_i1z5z.i1z5i10r1f] = {};
    }
    if (!_dz[_i1z5z.i1z5i10r1f][_i1z5z.i1z5i1111f]) {
      _dz[_i1z5z.i1z5i10r1f][_i1z5z.i1z5i1111f] = {};
    }
    _dz[_i1z5z.i1z5i10r1f][_i1z5z.i1z5i1111f][_i1z5z.i1z5d1100s] = {
      i1z5a1100i: _i1z5z.i1z5a1100i,
      i1z5a2100i: _i1z5z.i1z5a2100i,
    };
    _i1z5z.cldz.i10rs?.map((_i10rz: _ht.dz) => {
      if (!_dz[_i10rz._fst]) {
        _dz[_i10rz._fst] = {};
      }
      if (!_dz[_i10rz._fst][_i1z5z.i1z5i1111f]) {
        _dz[_i10rz._fst][_i1z5z.i1z5i1111f] = {};
      }
      if (!_dz[_i10rz._fst][_i1z5z.i1z5i1111f][_i1z5z.i1z5d1100s]) {
        _dz[_i10rz._fst][_i1z5z.i1z5i1111f][_i1z5z.i1z5d1100s] = {
          i1z5a1100i: 0,
          i1z5a2100i: 0,
        }
      }
      if (_i1z5z.i1z5a1100i > 0) {
        _dz[_i10rz._fst][_i1z5z.i1z5i1111f][_i1z5z.i1z5d1100s].i1z5a1100i = 1;
      }
    })
  });
  return _dz;
};
*/
export const loadI1z5RzAsync = async ( pz: {
  _31r_fst: _ht.n,
  i10r_fsts?: _ht.ls,
  dates?: _ht.ls,
  i1zrd3100sStt?: _ht.s,
  i1zrd3100sEnd?: _ht.s,
}) => {

//  const _gUserz = gs.useUserz();

  const _i10rs = await _cmFTH.loadLsAsync({ // pz.i10r_fsts を親部屋とする子部屋の一覧
    tgt: 'i10rs',
    cdn: _cmFTH.vdd() + ` AND _fst IN (${_hm.join(pz.i10r_fsts)})`,
    lwrz: {
      i102s: { // 親部屋, i10rs を _key で引き当てており、最新情報でない場合があることに留意
        tgt: 'i102s',
        cdn: _cmFTH.vdd(false) + ` AND i102i10r1k = {i102i10r1k}`,
        rlcz: {
          i102i10r1k: 'i10rs._key',
        }
      }
    }
  });

  const _i10r_fstz = {
    alls: [], 
    // prtz: {}, 
    cldz: {} 
  } as _ht.dz;
  _i10rs.map((_i10rz: _ht.dz) => {
    const _i10rPrtKey = String(_i10rz._fst);
//  _hm.l(`icvI1z___Mz 646: ${_i10rPrtKey}`)
    _i10r_fstz.alls.push(_i10rPrtKey);    
/*
    if (!_i10r_fstz.prtz[_i10rPrtKey]) _i10r_fstz.prtz[_i10rPrtKey] = [];
    _i10r_fstz.prtz[_i10rPrtKey].push(_i10rPrtKey);
*/
    if (!_i10r_fstz.cldz[_i10rPrtKey]) _i10r_fstz.cldz[_i10rPrtKey] = [];
    _i10r_fstz.cldz[_i10rPrtKey].push(_i10rPrtKey);
    _i10rz.cldz.i102s.map((_i102z: _ht.dz) => {
      const _i10rCldKey = String(_i102z.i102i10r1f);
      _i10r_fstz.alls.push(_i10rCldKey);    
/*  
      _i10r_fstz.prtz[_i10rPrtKey].push(_i10rCldKey);
*/
      if (!_i10r_fstz.cldz[_i10rCldKey]) _i10r_fstz.cldz[_i10rCldKey] = [];
      _i10r_fstz.cldz[_i10rCldKey].push(_i10rPrtKey);
    });
  })

  let _cdn = _cmFTH.vdd(false) + ` AND i1z5_31r1f=${pz._31r_fst}`;
  if (_hm.f(_i10r_fstz.alls)) _cdn += ` AND i1z5i10r1f IN (${_hm.join(_i10r_fstz.alls)})`;
  if (pz.dates) _cdn += ` AND i1z5d1100s IN (${_hm.join(pz.dates, ',', `'`)})`;
  if (_hm.f(pz.i1zrd3100sStt)) _cdn += ` AND i1z5d1100s >= '${pz.i1zrd3100sStt}'`;
  if (_hm.f(pz.i1zrd3100sEnd)) _cdn += ` AND i1z5d1100s <= '${pz.i1zrd3100sEnd}'`;


  const _i1z5s = await _cmFTH.loadLsAsync({
    tgt: 'i1z5s',
    cdn: _cdn,
  });

  const _dz = {} as _ht.dz;
  _i1z5s.map((_i1z5z: _ht.dz) => {
    const _i10rPrtKey = String(_i1z5z.i1z5i10r1f);
    //hf.l(`icvI1z___Mz 675: ${_i10rPrtKey}`)
    const _i1111f = String(_i1z5z.i1z5i1111f);
    const _d1100s = String(_i1z5z.i1z5d1100s);
/*
    _i10r_fstz.prtz[_i10rPrtKey].map((_i10r_fst: _ht.n) => {
      const _i10rTgtKey = String(_i10r_fst);
      if (!_dz[_i10rTgtKey]) _dz[_i10rTgtKey] = {};
      if (!_dz[_i10rTgtKey][_i1111f]) _dz[_i10rTgtKey][_i1111f] = {};
      if (!_dz[_i10rTgtKey][_i1111f][_d1100s]) _dz[_i10rTgtKey][_i1111f][_d1100s] = { i1z5a1100i: 0, i1z5a2100i: 0 };
      if (_i1z5z.i1z5a1100i > 0) _dz[_i10rTgtKey][_i1111f][_d1100s].i1z5a1100i = 1;
      if (_i1z5z.i1z5a2100i > 0) _dz[_i10rTgtKey][_i1111f][_d1100s].i1z5a2100i = 1;
    });
*/
    _i10r_fstz.cldz[_i10rPrtKey].map((_i10r_fst: _ht.n) => {
      const _i10rTgtKey = String(_i10r_fst);
      if (!_dz[_i10rTgtKey]) _dz[_i10rTgtKey] = {};
      if (!_dz[_i10rTgtKey][_i1111f]) _dz[_i10rTgtKey][_i1111f] = {};
      if (!_dz[_i10rTgtKey][_i1111f][_d1100s]) _dz[_i10rTgtKey][_i1111f][_d1100s] = { i1z5a1100i: 0, i1z5a2100i: 0 };
      if (_i1z5z.i1z5a1100i > 0) _dz[_i10rTgtKey][_i1111f][_d1100s].i1z5a1100i = 1;
//      if (_i1z5z.i1z5a2100i > 0) _dz[_i10rTgtKey][_i1111f][_d1100s].i1z5a2100i = 1;
      if (_i1z5z.i1z5a2100i > 0) _dz[_i10rTgtKey][_i1111f][_d1100s].i1z5a2100i = _i1z5z.i1z5a2100i;
    });
  });

  //hf.l(`icvI1z___Mz 646: ${_hm.s(_i1z5s)}`)

  return _dz;
};

export const saveI1zrDzAsync = async ( pz: {
  i1zz: _ht.dz,
  i10rs: _ht.ls,
  i17rs: _ht.ls,
  i15rs: _ht.ls,
  i18rz: _ht.dz,
  hdys: _ht.ls,
} ) => {
  //_hm.l(`icvI1z___Mz 703a: ` + _hm.s(pz.i1zz.i1z1s));
  const _prmz = ihdI1z.grtPzForSaveI1zrDz(_cm.grtUz(), pz);
  //_hm.l(`icvI1z___Mz 703b: ` + _hm.s({ ... _prmz.lwrz?.i1z1s.ls[0], cldz: undefined }));
  const _dz = await _cmFTH.ugdDzAsync(_prmz); // !!!!!!!! 要修正
  //const _dz = { _fst: 0 };
  //_hm.l(`icvI1z___Mz 703c: ` + _hm.s(_dz));
  const _dz2 = 
    _dz._fst ? 
    await loadI1zrDzAsync({
      i1zr_fst: _dz._fst
    })
    : {} as _ht.dz;
  //_hm.l(`icvI1z___Mz 703d: here`);
  return _dz2;
};

export const chkI1zAsync = async (pz: { // check booked async
  role: 's' | 'd', // s: スタッフ, d: 団体,
  ctt: 'r' | 'e', // r: 予約, e: エントリー
  _31r_fst: _ht.n,
  i1zz: _ht.dz,
  i10rs: _ht.ls,
  i17rs: _ht.ls,
  sMsgz: _ht.dz,
  step: _ht.n,
}) => {

  //_hm.l(`icvIz1z___Mz 859a: ${_hmDTM.getNow()}`);

  const _gUserz = gs.useUserz();

  const _gStgz = gs.useStgz();

  const _showMsg = (msg: _ht.s) => {
    pz.sMsgz.show({
      textCz: {
        textz: {
          pfx: msg,
        }
      }
    });
  };

/*
  const _i10rs = await icvI10___Mz.loadI10rLsAsync({
    _31r_fst: pz._31r_fst,
  });
*/
  //hf.l(`icm 50: ${pz.role}, ${pz.ctt}, ${pz._31r_fst}, ${pz.step}`)

  const _tdy = _hmDTM.getTdy();
  //const _tdy = _gStgz.crt.tdy; _hm.l(`icm 751: ${_tdy}`); // テスト用

  const _dz = {
    _611s: [],
    rsvYearMth: '',
    rsvCnt: 0,
    alyYearMth: '',
    alyCnt: 0,
    //i17rs: [],
    bChkEmtCnt: true,
    bChkRsvDct: true,
    //bChkAvlRoom: true, // available room
  };
  await _hm.ectPrlAsync([
/*
    async () => {
      if ( _hm.i(pz.role, ['s', 'd']) && _hm.i(pz.ctt, ['r', 'e']) ) { // 団体種別において予約不可の部屋が選択されていないか確認
        const _i10rs = await icvI10___Mz.loadI10rLsAsync({
          _31r_fst: pz.i1zz.i1zrz.i1zr_31r1f,
          i18r_fst: pz.i1zz.i1zrz.i1zri18r1f,
        });
        const _i10r_fsts = _i10rs.map((i10rz: _ht.dz) => i10rz._fst);
        ihd.nd(pz.i1zz.i1z1s).map((i1z1z: _ht.dz) => async () => {
          if (_hm.i(i1z1z.i1z1i10r1f, _i10r_fsts) == false) _dz.bChkAvlRoom = false;
        });
      }
    },
*/
    async () => {
      if ( _hm.i(pz.role, ['d']) && _hm.i(pz.ctt, ['r', 'e']) ) {
        _dz._611s = await _cv_61___Mz.load_611AsAsync({
          date: pz.i1zz.i1zrz.i1zrd3100s,
          cdn: `_611_31r1f=${pz.i1zz.i1zrz.i1zr_31r1f}`
        });
      }
    },
    async () => {
      if ( _hm.i(pz.role, ['d']) && _hm.i(pz.ctt, ['r']) ) {
        _dz.rsvYearMth = _hmDTM.f(pz.i1zz.i1zrz.i1zrd3100s, 'YYYY-MM');
        //_hm.l(`icvI1z___Mz 901: ${_hm.s(_gUserz.crt.i18rz)}`);
/*
        const _ls = await loadI1zrLsAsync({
          i18r_fst: _gUserz.crt.i18rz._fst,
          _31r_fst: pz.i1zz.i1zrz.i1zr_31r1f,
          i1zr_fst: pz.i1zz.i1zrz._fst,
          i1zrs1100iMnm: 70,
          yearMth: _dz.rsvYearMth,
        });
*/
        const _i1zrd3100sStt = 
          _hmDTM.getTdy() >= (_dz.rsvYearMth + '-01') ?
            _hmDTM.getTdy()
          : (_dz.rsvYearMth + '-01') 
        const _ls = await loadI1zrLsAsync({ // 対象月の利用日以降が対象
          i18r_fst: _gUserz.crt.i18rz._fst,
          _31r_fst: pz.i1zz.i1zrz.i1zr_31r1f,
          i1zr_fst: pz.i1zz.i1zrz._fst,
          i1zrs1100iMnm: 70,
          i1zrd3100sStt: _i1zrd3100sStt,
          i1zrd3100sEnd: _hmDTM.cvtLdm(_i1zrd3100sStt),
        });
        _dz.rsvCnt = _ls.length;
        //_hm.l(`ivI1z___Mz 818: ${_i1zrd3100sStt}, ${_dz.rsvCnt}`)
      }
    },
    async () => {
      if ( _hm.i(pz.role, ['d']) && _hm.i(pz.ctt, ['e']) ) {
        _dz.alyYearMth = _hmDTM.f(pz.i1zz.i1zrz.i1zrd3100s, 'YYYY-MM');
        const _ls = await loadI1zrLsAsync({
          i18r_fst: _gUserz.crt.i18rz._fst,
          _31r_fst: pz.i1zz.i1zrz.i1zr_31r1f,
          i1zr_fst: pz.i1zz.i1zrz._fst,
          i1zrs1200iMnm: 70,
          yearMth: _dz.alyYearMth,
        });
        _dz.alyCnt = _ls.length;
      }
    },
    async () => {
      if ( _hm.i(pz.role, ['s', 'd']) && _hm.i(pz.ctt, ['r']) ) {
        //_hm.l(`icvIz1z___Mz 932a: ${_hmDTM.getNow()}`);
        //_hm.l(`icvIz1z___Mz 932b: ${_hmDTM.getNow()}`);
        await _hm.ectPrlAsync(
          ihd.nd(pz.i1zz.i1z2s).map((_i1z2z: _ht.dz) => async () => {
            const _ls = await loadI1z2LsAsync({
              _31r_fst: pz._31r_fst,
              i17r_fst: _i1z2z.i1z2i17r1f,
              i1zr_fst: pz.i1zz.i1zrz._fst,
              i1zrs1100iMnm: 70,
              i1zrd3100s: pz.i1zz.i1zrz.i1zrd3100s,
              i1z2a1100i: _i1z2z.i1z2a1100i,
              i1z2a1200i: _i1z2z.i1z2a1200i,
              fld: '*',
            });
            //hf.l(`icvI1z___Max 1083a: ${_i1z2z.i1z2i17r1f}, ${_hm.s(_i17rs)}`)
            const _i17rz = _hm.getDz(pz.i17rs, _i1z2z.i1z2i17r1f, '_fst');
            const _i17ra1100i = _i17rz?.i17ra1100i ?? 1;
            const _rsvCntI1z2 = ihm.getRsvCntI1z2(_ls);
            //hf.l(`icvI1z___Max 1083b: ${_rsvCntI1z2}, ${_i17ra1100i}`)
            if (_rsvCntI1z2 >= _i17ra1100i) { // 備品・駐車場の重複ありの場合
              _dz.bChkEmtCnt = false;
            } 

          }) ?? []
        );    
        //_hm.l(`icvIz1z___Mz 932c: ${_hmDTM.getNow()}`);
      };
    },
    async () => {
      if ( _hm.i(pz.role, ['s', 'd']) && _hm.i(pz.ctt, ['r', 'e']) ) { // icm.sendEtlAsync にも同様の処理あり
        //_hm.l(`icvIz1z___Mz 831a: ${_hmDTM.getNow()}`);
        await _hm.ectPrlAsync( // icmsendEtlAsync にも同様の処理あり
          icm.getI1z1Atv(pz.i1zz.i1z1s) // 空欄以外 かつ 未削除
          .map((_i1z1z: _ht.dz) => async () => {
            //_hm.l(`icvI1z___Mz 831b: ${_hm.s(_i1z1z)}`);
            const _dz2 = { // これが重い
              _31r_fst: pz.i1zz.i1zrz.i1zr_31r1f,
              i10r_fst: _i1z1z.i1z1i10r1f,
              i1zr_fst: pz.i1zz.i1zrz._fst, // 自身を除く
              i1zrs1100iMnm: 70,
              i1zrd3100s: pz.i1zz.i1zrz.i1zrd3100s,
              i1z1a1100i: _i1z1z.i1z1a1100i,
              i1z1a1200i: _i1z1z.i1z1a1200i,
              fld: '*',
            };
            const _ls = await loadI1z1LsAsync(_dz2);
            //_hm.l(`icvI1z___Mz 831c: ${_hm.s(_dz2)}`);
            //_hm.l(`icvI1z___Mz 831d: ${_hm.s(_ls)}`);
            if (_ls.length > 0) _dz.bChkRsvDct = false;
          })
        )
        //_dz.bChkRsvDct = true; // 2/2
        //_hm.l(`icvIz1z___Mz 831e: ${_hmDTM.getNow()}`);
      }
    },
  ]);
  //_hm.l(`icvIz1z___Mz 859b: ${_hmDTM.getNow()}`);

  const _r = await _hm.ectSrlAsync([
    async () => { // エントリー受付期間のチェック # 団体 - エントリー
      //hf.l('icvI1z___Mz 670: here');
      let _b = true;
      if ( _hm.i(pz.role, ['d']) && _hm.i(pz.ctt, ['e']) ) {

        if ( _tdy < _gStgz.crt.alySttDate || _tdy > _gStgz.crt.alyEndDate) _b = false;
        if (!_b) {
//          _showMsg(`エントリー受付期間外のため、指定された操作を行うことができません`);
          _showMsg(`エントリー受付期間外のため、指定された操作を行うことができません`);
        }
      }
      return _b;
    },
    async () => { // キャンセル状況のチェック # 団体 - 予約
      //hf.l('icvI1z___Mz 683: here');
      let _b = true;
      if ( _hm.i(pz.role, ['d']) && _hm.i(pz.ctt, ['r']) ) {
//        if (pz.i1zz.i1zrz.i1zrs1100i == 20) _b = false;
        if (_hm.i(pz.i1zz.i1zrz.i1zrs1100i, [22, 24, 26])) _b = false;
        if (!_b) {
          _showMsg(`予約がキャンセル済のため、指定された操作を行うことができません`);
        }
      }
      return _b;
    },
    async () => { // キャンセル状況のチェック # 団体 - エントリー
      //hf.l('icvI1z___Mz 695: here');
      let _b = true;
      if ( _hm.i(pz.role, ['d']) && _hm.i(pz.ctt, ['e']) ) {
        if (pz.i1zz.i1zrz.i1zrs1200i == 20) _b = false;
        if (!_b) {
          _showMsg(`エントリーがキャンセル済のため、指定された操作を行うことができません`);
        }
      }
      return _b;
    },
    async () => { // 時間帯の件数の確認 # スタッフ - 予約・エントリ
      //hf.l('icvI1z___Mz 706: here');
      let _b = true;
      if ( _hm.i(pz.role, ['s']) && _hm.i(pz.ctt, ['r', 'e']) ) {
        if (icm.getI1z1Atv(pz.i1zz.i1z1s).length > icv.nI1z1CntMax) _b = false;
        if (!_b) {
          _showMsg(`同一日に ${icv.nI1z1CntMax+1}件以上の時間帯が設定されているため、指定された操作を行うことができません`);
        }
      }
      return _b;
    },
    async () => { // 入力必須項目の確認 # スタッフ - 予約・エントリ - 部屋・日時の選択
      //hf.l('icvI1z___Mz 717: here');
      let _b = true;
      if ( _hm.i(pz.role, ['s']) && _hm.i(pz.ctt, ['r', 'e']) && pz.step >= 1 ) {
        if (!_hm.f(pz.i1zz.i1zrz.i1zrd3100s)) _b = false; // 利用日
        let _nCnt = 0;
        ihd.nd(pz.i1zz.i1z1s).map( (_i1z1z: _ht.dz) => {
//hf.l(`icvI1z___Mz 693: ${_hm.s(_i1z1z)}`);
          if (_i1z1z._dlt != 1) {
            let _n = 0;
            if (_i1z1z.i1z1i10r1f > 0) {
//hf.l(`icvI1z___Mz 697: here`);
              _n += 1; // 部屋
            }
            if (_i1z1z.i1z1i1111f > 0 || _i1z1z.i1z1i1111f == -999) {
//hf.l(`icvI1z___Mz 702: here`);
              _n += 1; // 時間帯
            }
            if (_i1z1z.i1z1a1100i) {
//hf.l(`icvI1z___Mz 707: here`);
              _n += 1; // 開始時刻
            }
//hf.l(`icvI1z___Mz 711: here`);
            if (_i1z1z.i1z1a1200i) {
              _n += 1; // 終了時刻
            }
            if ( _n > 0 && _n < 4 ) {
//hf.l(`icvI1z___Mz 716: here`);
              _b = false; // 欠けている項目が存在する場合
            }
            if ( _n == 4 ) _nCnt += 1;
          }
        })
        if (_nCnt == 0) {
          _b = false;
        }
        if (!_b) {
          _showMsg(`入力されていない項目があるため、指定された操作を行うことができません`);
        }
      }
      return _b;
    },
    async () => { // 入力必須項目の確認 # スタッフ - 予約・エントリ - 団体の選択
      //hf.l('icvI1z___Mz 763: here');
      let _b = true;
      if ( _hm.i(pz.role, ['s']) && _hm.i(pz.ctt, ['r', 'e']) && pz.step >= 2 ) {
        if ( !pz.i1zz.i1zrz.i1zri18r1f || pz.i1zz.i1zrz.i1zri18r1f <= 0 ) _b = false; // 団体
        if (!_b) {
          _showMsg(`入力されていない項目があるため、指定された操作を行うことができません`);
        }
      }
      return _b;
    },
    async () => { // 入力必須項目の確認 # スタッフ - 予約・エントリー - 詳細
      //hf.l('icvI1z___Mz 774: here');
      let _b = true;
      if ( _hm.i(pz.role, ['s']) && _hm.i(pz.ctt, ['r', 'e']) && pz.step >= 3 ) {
        if (
          !_hm.f(pz.i1zz.i1zrz.i1zra2100s) || // 申込者
          !_hm.f(pz.i1zz.i1zrz.i1zrd1100s) || // 登録日
          !_hm.f(pz.i1zz.i1zrz.i1zrd2100s) // 申込日
        ) _b = false;
        if (!_b) {
          _showMsg(`入力されていない項目があるため、指定された操作を行うことができません`);
        }
      }
      return _b;
    },
    async () => { // 入力必須項目の確認 # スタッフ - 予約 - 予約詳細
      //hf.l('icvI1z___Mz 791: here');
      let _b = true;
      if ( _hm.i(pz.role, ['s']) && _hm.i(pz.ctt, ['r']) && pz.step >= 3 ) {
        if (
          !_hm.f(pz.i1zz.i1z3z.i1z3d1100s) || // 支払期限
          (pz.i1zz.i1z3z.i1z3t1100i > 0 && !(pz.i1zz.i1z3z.i1z3t2100i > 0)) // 減免理由
        ) {
          _b = false;
        };
        if (!_b) {
          _showMsg(`入力されていない項目があるため、指定された操作を行うことができません`);
        }
      }
      return _b;
    },
    async () => { // 入力必須項目の確認 # 団体 - 予約・エントリー
      //hf.l('icvI1z___Mz 808: here');
      let _b = true;
      if ( _hm.i(pz.role, ['d']) && _hm.i(pz.ctt, ['r', 'e']) ) {
        if (!_hm.f(pz.i1zz.i1zrz.i1zrd3100s)) _b = false; // 利用日
        let _nCnt = 0;
        ihd.nd(pz.i1zz.i1z1s).map( (_i1z1z: _ht.dz) => {
          if (_i1z1z._dlt != 1) {
            let _n = 0;
            if (_i1z1z.i1z1i10r1f > 0) _n += 1; // 部屋
            if (_i1z1z.i1z1i1111f > 0 || _i1z1z.i1z1i1111f == -999) _n += 1; // 時間帯
            if (_i1z1z.i1z1a1100i) _n += 1; // 開始時刻
            if (_i1z1z.i1z1a1200i) _n += 1; // 終了時刻
            if ( _n > 0 && _n < 4 ) _b = false; // 欠けている項目が存在する場合
            if ( _n == 4 ) _nCnt += 1;
          }
        })
        if (_nCnt == 0) _b = false;
        if (!_b) {
          _showMsg(`入力されていない項目があるため、指定された操作を行うことができません`);
        }
      }
      return _b;
    },
    async () => { // 休館日の確認 # 団体 - 予約・エントリー
      //hf.l('icvI1z___Mz 836: here');
      let _b = true;
      if ( _hm.i(pz.role, ['d']) && _hm.i(pz.ctt, ['r', 'e']) ) {
/*
        const _611s = await _cv_61___Mz.load_611AsAsync({
          date: pz.i1zz.i1zrz.i1zrd3100s,
          cdn: `_611_31r1f=${pz.i1zz.i1zrz.i1zr_31r1f}`

        });
*/
        if (_hm.i(pz.i1zz.i1zrz.i1zrd3100s, _dz._611s)) _b = false;
        if (!_b) {
          _showMsg(`指定した利用日が休館日であるため、指定された操作を行うことができません`);
        }
      }
      return _b;
    },
    async () => { // 予約受付対象外の利用日の確認 # 団体 - 予約
      //hf.l('icvI1z___Mz 853: here');
      let _b = true;
      if ( _hm.i(pz.role, ['d']) && _hm.i(pz.ctt, ['r']) ) {
        if (
          pz.i1zz.i1zrz.i1zrd3100s < _gStgz.crt.rsvSttDate ||
          pz.i1zz.i1zrz.i1zrd3100s > _gStgz.crt.rsvEndDate
        ) _b = false;
        //hf.l(`icvI1z___Mz 849: ${pz.i1zz.i1zrz.i1zrd3100s}, ${_gStgz.crt.rsvSttDate}, ${_gStgz.crt.rsvEndDate}, ${_b}`);
        if (!_b) {
          _showMsg(`予約受付対象外の利用日であるため、指定された操作を行うことができません`);
        }
      }
      return _b;
    },
    async () => { // エントリー受付対象外の利用日の確認 # 団体 - エントリー
      //hf.l(`icvI1z___Mz 868: ${pz.role}, ${pz.ctt}`);
      let _b = true;
      if ( _hm.i(pz.role, ['d']) && _hm.i(pz.ctt, ['e']) ) {
        if (
          pz.i1zz.i1zrz.i1zrd3100s < _gStgz.crt.alyMthSttDate ||
          pz.i1zz.i1zrz.i1zrd3100s > _gStgz.crt.alyMthEndDate
        ) _b = false;
        //hf.l(`icvI1z___Mz 863: ${_b} ${pz.i1zz.i1zrz.i1zrd3100s}, ${_gStgz.crt.alyMthSttDate}, ${_gStgz.crt.alyMthEndDate}`);
        if (!_b) {
          _showMsg(`エントリー受付対象外の利用日であるため、指定された操作を行うことができません`);
        }
      }
      return _b;
//      return false;
    },

    async () => { // 予約最大件数の確認 # 団体 - 予約
      //hf.l('icvI1z___Mz 885: here');
      let _b = true;
//hf.l(`icvI1z___Mz 806: ${pz.role}, ${pz.ctt}`);
      if ( _hm.i(pz.role, ['d']) && _hm.i(pz.ctt, ['r']) ) {
        //let _rsvYearMth = _hmDTM.f(pz.i1zz.i1zrz.i1zrd3100s, 'YYYY-MM');
        //hf.l(`icvI1z___Mz 398: ${_rsvYearMth}, ${_hm.s(_gStgz.crt)}`);
        let _rsvMaxCnt = _gStgz.crt.rsvMaxCntz[_dz.rsvYearMth];
//hf.l(`icvI1z___Mz 811: ${_rsvYearMth}, ${_rsvMaxCnt}`);
/*
        const _ls = await loadI1zrLsAsync({
          i18r_fst: _gUserz.crt.i18rz._fst,
          //_31r_fst: pz.i1zz.i1zrz.i1zr_31r_fst,
          _31r_fst: pz.i1zz.i1zrz.i1zr_31r1f,
          i1zr_fst: pz.i1zz.i1zrz._fst,
          i1zrs1100iMnm: 70,
          yearMth: _rsvYearMth,
        });
        if ( _ls.length >= _rsvMaxCnt ) _b = false;
*/
        if ( _dz.rsvCnt >= _rsvMaxCnt ) _b = false;
//hf.l(`icvI1z___Mz 820: ${_ls.length}, ${_b}`);
        if (!_b) {
          _showMsg(`予約が最大数（${_rsvMaxCnt}件）を超えているため、指定された操作を行うことができません`);
        }
      }
      return _b;
    },

    async () => { // エントリー最大件数の確認 # 団体 - エントリー
      //hf.l('icvI1z___Mz 910: here');
      let _b = true;
      if ( _hm.i(pz.role, ['d']) && _hm.i(pz.ctt, ['e']) ) {
        //let _alyYearMth = _hmDTM.f(pz.i1zz.i1zrz.i1zrd3100s, 'YYYY-MM');
        let _alyMaxCnt = _gStgz.crt.S07010212;
/*
        const _ls = await loadI1zrLsAsync({
          i18r_fst: _gUserz.crt.i18rz._fst,
          _31r_fst: pz.i1zz.i1zrz.i1zr_31r1f,
          i1zr_fst: pz.i1zz.i1zrz._fst,
          i1zrs1200iMnm: 70,
          yearMth: _alyYearMth,
        });
        if ( _ls.length >= _alyMaxCnt ) _b = false;
*/
        if ( _dz.alyCnt >= _alyMaxCnt ) _b = false;
        //hf.l(`icvI1z___Mz 841: ${pz.i1zz.i1zrz.i1zr_31r1f}, ${_alyYearMth}, ${_ls.length}, ${_alyMaxCnt}, ${_b}, ${_hm.s(_ls)}`);
        if (!_b) {
          _showMsg(`エントリーが最大数（${_alyMaxCnt}件）を超えているため、指定された操作を行うことができません`);
        }
      }
      return _b;
    },

    async () => { // 備品・駐車場の重複の確認（自身を除く） - スタッフ・団体 - 予約・エントリ
      //hf.l('icvI1z___Mz 932: here');
      let _b = true;
      if ( _hm.i(pz.role, ['s', 'd']) && _hm.i(pz.ctt, ['r', 'e']) ) {
        let _i17rz = {} as _ht.dz;
        ihd.nd(pz.i1zz.i1z2s).map( (_i1z2z: _ht.dz) => {
          if (!_i17rz[_i1z2z.i1z2i17r1f]) _i17rz[_i1z2z.i1z2i17r1f] = 0;
          _i17rz[_i1z2z.i1z2i17r1f] += 1;
          if (_i17rz[_i1z2z.i1z2i17r1f] > 1) _b = false;
        })
        if (!_b) {
          _showMsg(`備品・駐車場が重複して選択されているため、指定された操作を行うことができません`);
        }
      }
      return _b;
    },

    async () => { // 備品・駐車場の最大予約数の確認（自身を除く） - スタッフ・団体 - 予約
      //hf.l('icvI1z___Mz 949: here');
      //let _b = true;_dz.bChkEmtCnt;
      let _b = _dz.bChkEmtCnt;
      if ( _hm.i(pz.role, ['s', 'd']) && _hm.i(pz.ctt, ['r']) ) {
/*
        const _i17rs = await icvI17___Mz.loadI17rLsAsync({
          _31r_fst: pz._31r_fst,
        });
        await Promise.all(
          ihd.nd(pz.i1zz.i1z2s).map( async (_i1z2z: _ht.dz) => {
            const _ls = await loadI1z2LsAsync({
              _31r_fst: pz._31r_fst,
              i17r_fst: _i1z2z.i1z2i17r1f,
              i1zr_fst: pz.i1zz.i1zrz._fst,
              i1zrs1100iMnm: 70,
              i1zrd3100s: pz.i1zz.i1zrz.i1zrd3100s,
              i1z2a1100i: _i1z2z.i1z2a1100i,
              i1z2a1200i: _i1z2z.i1z2a1200i,
              fld: '*',
            });
            //hf.l(`icvI1z___Max 1083a: ${_i1z2z.i1z2i17r1f}, ${_hm.s(_i17rs)}`)
            const _i17rz = _hm.getDz(_i17rs, _i1z2z.i1z2i17r1f, '_fst');
            const _i17ra1100i = _i17rz?.i17ra1100i ?? 1;
            const _rsvCntI1z2 = ihm.getRsvCntI1z2(_ls);
            //hf.l(`icvI1z___Max 1083b: ${_rsvCntI1z2}, ${_i17ra1100i}`)
            if (_rsvCntI1z2 >= _i17ra1100i) { // 備品・駐車場の重複ありの場合
              _b = false;
            } 

          }) ?? []
        );
*/
/*
        await _hm.ectPrlAsync(
          ihd.nd(pz.i1zz.i1z2s).map((_i1z2z: _ht.dz) => async () => {
            const _ls = await loadI1z2LsAsync({
              _31r_fst: pz._31r_fst,
              i17r_fst: _i1z2z.i1z2i17r1f,
              i1zr_fst: pz.i1zz.i1zrz._fst,
              i1zrs1100iMnm: 70,
              i1zrd3100s: pz.i1zz.i1zrz.i1zrd3100s,
              i1z2a1100i: _i1z2z.i1z2a1100i,
              i1z2a1200i: _i1z2z.i1z2a1200i,
              fld: '*',
            });
            //hf.l(`icvI1z___Max 1083a: ${_i1z2z.i1z2i17r1f}, ${_hm.s(_i17rs)}`)
            const _i17rz = _hm.getDz(_dz.i17rs, _i1z2z.i1z2i17r1f, '_fst');
            const _i17ra1100i = _i17rz?.i17ra1100i ?? 1;
            const _rsvCntI1z2 = ihm.getRsvCntI1z2(_ls);
            //hf.l(`icvI1z___Max 1083b: ${_rsvCntI1z2}, ${_i17ra1100i}`)
            if (_rsvCntI1z2 >= _i17ra1100i) { // 備品・駐車場の重複ありの場合
              _b = false;
            } 

          }) ?? []
        );
        if (!_b) {
          _showMsg(`選択した備品・駐車場の予約数が最大数を超えているため、指定された操作を行うことができません`);
        }
*/
        if (!_b) {
          _showMsg(`選択した備品・駐車場の予約数が最大数を超えているため、指定された操作を行うことができません`);
        }
      }
      return _b;
    },

    async () => { // 時間帯の連続性の確認 - 団体 - 予約・エントリ
      let _b = true;
      if ( _hm.i(pz.role, ['s', 'd']) && _hm.i(pz.ctt, ['r', 'e']) ) {
        let _ttl = 0;
        const _roomz = {} as _ht.dz;
        ihd.nd(pz.i1zz.i1z1s).map((_i1z1z: _ht.dz) => {
          _ttl += _i1z1z.i1z1a1200i - _i1z1z.i1z1a1100i;
          _roomz[String(_i1z1z.i1z1i10r1f)] = true;
        })
        const _roomCnt = Object.keys(_roomz).length;
        const _avg = _ttl / (pz.i1zz.i1zrz.i1zrd4200i - pz.i1zz.i1zrz.i1zrd4100i) / _roomCnt;
        //hf.l(`icvI1z___Mz 1135: ${_roomCnt}, ${_ttl}, ${pz.i1zz.i1zrz.i1zrd4200i}, ${pz.i1zz.i1zrz.i1zrd4100i}, ${_avg}`);
        if ( _avg < 1 ) _b = false;
        if (!_b) {
          _showMsg(`選択した部屋において時間帯が連続していないため、指定された操作を行うことができません`);
        }
      }
      return _b;
    },

    async () => { // 時間帯の最大数の確認 - 団体 - 予約・エントリ
      //hf.l('icvI1z___Mz 997: here');
      let _b = true;
      if ( _hm.i(pz.role, ['d']) && _hm.i(pz.ctt, ['r', 'e']) ) {
        const _i1z1s = ihd.nd(pz.i1zz.i1z1s);
        const _i1z1z = _hm.f(_i1z1s) ? _i1z1s[0] : [];
//        const _i10ra1100i = _hm.getDz(_i10rs, _i1z1z.i1z1i10r1f, '_fst')?.i10ra1100i ?? 0;
        const _i10rz = _hm.getDz(pz.i10rs, _i1z1z.i1z1i10r1f, '_fst');
        const _i10ra1100i = _i10rz?.i10ra1100i ?? 0;
        if (_i1z1s.length > _i10ra1100i) _b = false;

        //_hm.l(`icvI1z___Mz 1230a: ${_hm.s(pz.i10rs)}`);
        //_hm.l(`icvI1z___Mz 1230b: ${_i1z1z.i1z1i10r1f}`);
        //_hm.l(`icvI1z___Mz 1230c: ${_hm.s(_i10rz)}`);
        //_hm.l(`icvI1z___Mz 1230d: ${_i10ra1100i}`);
        //_hm.l(`icvI1z___Mz 1230e: ${_i1z1s.length}`);
        if (!_b) {
          _showMsg(`選択した時間帯が最大数（${_i10ra1100i}件）を超えているため、指定された操作を行うことができません`);
        }
      }
      return _b;
    },

    async () => { // 一番最後に確認　：　部屋の重複予約の確認（自身を除く） # スタッフ・団体 - 予約・エントリー
      //hf.l('icvI1z___Mz 1012: here');
      //let _b = true;
      let _b = _dz.bChkRsvDct;
      if ( _hm.i(pz.role, ['s', 'd']) && _hm.i(pz.ctt, ['r', 'e']) ) {
        //hf.l(`icvI1z___Mz 1178a: ${_hm.s(pz.i1zz.i1z1s)}`);
        //hf.l(`icvI1z___Mz 1178b: ${_hm.s(icm.getI1z1Atv(pz.i1zz.i1z1s))}`);
/*
        await Promise.all(
          icm.getI1z1Atv(pz.i1zz.i1z1s) // 空欄以外 かつ 未削除
          .map( async (_i1z1z: _ht.dz) => {
            //hf.l(`icvI1z___Mz 1178c: ${_hm.s(_i1z1z)}`);
            const _ls = await loadI1z1LsAsync({
              _31r_fst: pz.i1zz.i1zrz.i1zr_31r1f,
              i10r_fst: _i1z1z.i1z1i10r1f,
              i1zr_fst: pz.i1zz.i1zrz._fst, // 自身を除く
              i1zrs1100iMnm: 70,
              i1zrd3100s: pz.i1zz.i1zrz.i1zrd3100s,
              i1z1a1100i: _i1z1z.i1z1a1100i,
              i1z1a1200i: _i1z1z.i1z1a1200i,
              fld: '*',
            });
            //hf.l(`icvI1z___Mz 1178d: ${_i1z1z.i1z1a1100i}, ${_i1z1z.i1z1a1200i}, ${_hm.s(_ls)}`);
            if (_ls.length > 0) _b = false;

          })
        )
*/
/*
        await _hm.ectPrlAsync(
          icm.getI1z1Atv(pz.i1zz.i1z1s) // 空欄以外 かつ 未削除
          .map((_i1z1z: _ht.dz) => async () => {
            //hf.l(`icvI1z___Mz 1178c: ${_hm.s(_i1z1z)}`);
            const _ls = await loadI1z1LsAsync({
              _31r_fst: pz.i1zz.i1zrz.i1zr_31r1f,
              i10r_fst: _i1z1z.i1z1i10r1f,
              i1zr_fst: pz.i1zz.i1zrz._fst, // 自身を除く
              i1zrs1100iMnm: 70,
              i1zrd3100s: pz.i1zz.i1zrz.i1zrd3100s,
              i1z1a1100i: _i1z1z.i1z1a1100i,
              i1z1a1200i: _i1z1z.i1z1a1200i,
              fld: '*',
            });
            //hf.l(`icvI1z___Mz 1178d: ${_i1z1z.i1z1a1100i}, ${_i1z1z.i1z1a1200i}, ${_hm.s(_ls)}`);
            if (_ls.length > 0) _b = false;
          })
        )
        //hf.l(`icvI1z___Mz 959: ${_b}`);
        if (!_b) {
          _showMsg(`選択した時間帯に他の予約があるため、指定された操作を行うことができません`);
        }
*/
//        if (!_dz.bChkRsvDct) {
        if (!_b) {
          _showMsg(`選択した時間帯に他の予約があるため、指定された操作を行うことができません`);
        }
      }
      return _b;
    },

  ]);

  //_hm.l(`icvIz1z___Mz 859c: ${_hmDTM.getNow()}`);

  return _r;
};
